// extracted by mini-css-extract-plugin
export default {"root":"_3B8bi","menu-item":"_2TeNi","menuItem":"_2TeNi","selected":"-EZeN"};